app.controller("SearchWatcherRemoveController",
	["$scope", "$http", "$timeout", function($scope, $http, $timeout) {
		$scope.title = '24h Etumatkan peruminen';
		$scope.Remove = function(searchWatcherId) {
			$http({
				method: "POST",
				url: "/api/km/KMSite/removeSearchWatch",
				data: {
					id: searchWatcherId
				}
			})
			.then(function (data) {
				$scope.title = '24h Etumatka peruttu';
				$scope.text = 'Emme jatkossa lähetä teille 24h Etumatkan viestejä.';
			}, 
			function (data) {
				$scope.title = 'Tapahtui virhe';
				$scope.text = 'Tapahtui odottamaton virhe. 24h Etumatkan poistaminen epäonnistui.';
			});
		};
	}]
);